import { useTranslate } from '@tolgee/react';
import DocumentsPage, {
  getStaticProps as fetcher,
  DocumentsPageProps,
} from '@amf/shared/pages/DocumentsPage';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';

export default function Page({ navigation, partners, documents }: DocumentsPageProps) {
  const { t } = useTranslate();
  return (
    <div className='DocumentsPage'>
      <Layout navigation={navigation} partners={partners}>
        <Meta title={t('documents.title')} />
        <DocumentsPage documents={documents} />
      </Layout>
    </div>
  );
}

export const getStaticProps = fetcher();
